import React from 'react';
import { BsCheckLg } from 'react-icons/bs';
import { HStack, Icon, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import colors from '../../../styles/theme/foundation/colors';

function BooleanRequirements({ displayName, isArchived = false }) {
  const textColors = isArchived
    ? { icon: colors.greyScale['800'], text: colors.greyScale['800'] }
    : { icon: colors.primaryScale['600'], text: colors.greyScale['900'] };

  return (
    <HStack alignItems="flex-start" mt={2}>
      <Icon
        as={BsCheckLg}
        boxSize="10px"
        color={textColors.icon}
        mt="5px"
      />
      <Text
        color={textColors.text}
        textStyle="bodySm500"
      >
        {displayName}
      </Text>
    </HStack>
  );
}

BooleanRequirements.propTypes = {
  displayName: PropTypes.string,
  isArchived: PropTypes.bool
};

export default BooleanRequirements;
